import { intersection } from 'zod';

import { useSelectSchoolInfo } from '../components/SectionBasicInfo/useSelectSchoolInfo';
import { BuildSchema } from '../form/schema';
import { getBuildSchoolInfoSchema } from '../form/schema/BuildSchoolInfoSchema';

/**
 *
 * 런타임에서 주입되는 데이터를 이용한 validation schema를 반환합니다.
 */
export const useBuildSchema = () => {
  const buildSchoolInfoSchema = useBuildSchoolInfoSchema();

  return intersection(BuildSchema, buildSchoolInfoSchema);
};

export const useBuildSchoolInfoSchema = () => {
  const { schoolNodes, gradeNodes, semesterNodes } = useSelectSchoolInfo();

  return getBuildSchoolInfoSchema({
    schoolNodes,
    gradeNodes,
    semesterNodes,
  });
};
